import { render, staticRenderFns } from "./RegistersPerPage.vue?vue&type=template&id=1e1cc538"
import script from "./RegistersPerPage.vue?vue&type=script&lang=js"
export * from "./RegistersPerPage.vue?vue&type=script&lang=js"
import style0 from "./RegistersPerPage.vue?vue&type=style&index=0&id=1e1cc538&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports